import { lazy } from 'react';

const Feedbacks = lazy(() => import('../pages/Feedbacks'));
const FeedbackMaintenance = lazy(() => import('../pages/FeedbackMaintenance'));
const FeedbackMaintenanceForm = lazy(() => import('../pages/FeedbackMaintenance/Form'));
const FeedbackMaintenanceEditForm = lazy(() => import('../pages/FeedbackMaintenance/EditForm'));

const feedbackRoute = {
  public: [],
  auth: [
    {
      name: 'feedback_maintenance',
      path: '/feedbacks/maintenance',
      component: FeedbackMaintenance,
      permissions: ['admin'],
    },
    {
      name: 'feedback_maintenance_form',
      path: '/feedbacks/maintenance/form',
      component: FeedbackMaintenanceForm,
      permissions: ['admin'],
    },
    {
      name: 'feedback_maintenance_edit_form',
      path: '/feedbacks/maintenance/edit/:id',
      component: FeedbackMaintenanceEditForm,
      permissions: ['admin'],
    },
    {
      name: 'feedbacks',
      path: '/feedbacks',
      component: Feedbacks,
      permissions: ['admin'],
    },
  ],
};

export default feedbackRoute;
